import { ofType } from "redux-observable";
import { filter, map } from "rxjs/operators";
import { selectShopAllOffers, selectShopCurrentShiftLevel, selectSmsOffers, } from "../../selectors/selectShopInfo";
import { utilNumber } from "../../utils/utilNumber";
import { actionAppsflyerPurchase } from "../appsflyer/actionAppsflyer";
import { TypeActionGrantRewards } from "../grant-rewards/actionGrantRewards";
import { TypeGrantRewards } from "../grant-rewards/TypeGrantRewards";
import { landingPageMessageHandler } from "../landing-page/landingPageMessageHandler";
export var epicGoogleTagMangerOfferPurchase = function (action$, state$) {
    return action$.pipe(ofType(TypeActionGrantRewards.Received), filter(function (action) { return action.rewardsType === TypeGrantRewards.Shop; }), map(function (action) {
        var state = state$.value;
        var isFirstPurchase = selectShopCurrentShiftLevel(state) <= 0;
        var offerId = action.rewards.paymentOfferId;
        var offers = selectShopAllOffers(state).concat(selectSmsOffers(state));
        var offer = offers.find(function (value) { return value.purchaseOfferNameId === offerId; });
        var currency = "";
        var price = "";
        var packageId = "";
        // currency is ISO3 currency format.
        // price is converted from cents to euros and formatted to string
        if (offer != undefined && offer.shopPackage != undefined) {
            currency = offer.shopPackage.currencyCode;
            price = utilNumber.convertFromCents(offer.shopPackage.price).toString();
            packageId = offer.shopPackage.packageId || "";
        }
        landingPageMessageHandler.onShopPurchaseComplete(isFirstPurchase, price, currency);
        return actionAppsflyerPurchase(currency, price, packageId, isFirstPurchase);
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/google-tag-manager/epicGoogleTagMangerOfferPurchase.ts
// module id = 1888
// module chunks = 3